import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import { StationFilters } from '../components/stations/StationFilters';
import 'leaflet/dist/leaflet.css';
// Generate random stations
const stations = Array.from({
  length: 200
}, (_, i) => ({
  id: i,
  lat: 20 + (Math.random() * 50 - 10),
  lng: -20 + (Math.random() * 100 - 40),
  name: `Station ${i + 1}`
}));
export function StationsView() {
  return <div className="jua-page-bg relative h-[calc(100vh-64px)] w-full" data-id="element-4205">
      {' '}
      {/* Removed "bg-[#0B1120]" to match comment */}
      <MapContainer center={[30, 10]} zoom={3} className="h-full w-full z-0" zoomControl={false} attributionControl={false} data-id="element-4206">
        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community" data-id="element-4207" />
        <TileLayer url="https://stamen-tiles-{s}.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}{r}.png" opacity={0.6} data-id="element-4208" />

        {stations.map(station => <CircleMarker key={station.id} center={[station.lat, station.lng]} radius={3} pathOptions={{
        color: '#EC4899',
        fillColor: '#EC4899',
        fillOpacity: 0.7,
        weight: 1
      }} data-id="element-4209">
            <Tooltip direction="top" offset={[0, -5]} opacity={1} className="custom-tooltip" data-id="element-4210">
              {station.name}
            </Tooltip>
          </CircleMarker>)}
      </MapContainer>
      <StationFilters data-id="element-4211" />
    </div>;
}